import React from 'react';
import styled, { css } from 'styled-components';
import { Nav } from '@catalogo/core-nav';
import Image from '@catalogo/ui-americanas-mobile-image';
import { getIn } from 'seamless-immutable';
import Select from './components/select';

export const ZionSelectShowcaseCover = ({ publication, renderComponent, history }) => {
  const {
    children,
    coverBtnText,
    coverUrl,
    imgCover,
    coverDescription,
    altTextCover,
    options,
    setSelectTitle,
    selectTitle,
  } = publication;

  const openModal = ({ altTextModal, imgModal, coverDescription, coverTitle, title }) => {
    const pathname = getIn(history, ['location', 'pathname'], '');
    const search = getIn(history, ['location', 'search'], '');

    history.push({
      pathname,
      search,
      hash: '#modal-select-showcase',
      state: { altTextModal, imgModal, coverDescription, coverTitle, title },
    });
  };
  return (
    <Container>
      <WrapperImage>
        <Image url={imgCover} alt={altTextCover} />
      </WrapperImage>
      <WrapperInfo>
        <SelectWrapper>
          <Select onSelected={setSelectTitle} value={selectTitle} options={options} />
        </SelectWrapper>
        <Description>
          <Text>{coverDescription}</Text>
          <SeeMore onClick={() => openModal(publication)}>leia mais</SeeMore>
        </Description>
        <List>
          {children.map(child => (
            <Item key={child?._id}>{renderComponent(child)}</Item>
          ))}
        </List>
        <Button to={coverUrl}>{coverBtnText}</Button>
      </WrapperInfo>
    </Container>
  );
};

export default ZionSelectShowcaseCover;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ebebeb;
  padding: 15px;
`;

const WrapperImage = styled.div`
  flex: 0 0 100%;
  width: 100%;
  margin-bottom: 15px;
`;

const WrapperInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  justify-content: flex-start;
`;

const Description = styled.div`
  ${({ theme }) => css`
    font-size: 14px;
    color: ${theme.grey.dark};
    line-height: 1.4;
    z-index: 1;
  `}
`;

const Text = styled.p`
  text-overflow: ellipsis;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;
const SeeMore = styled.button`
  ${({ theme }) => css`
    text-decoration: underline;
    background-color: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    outline: 0;
    cursor: pointer;
    font-size: 14px;
    color: ${theme.grey.dark};
    line-height: 1.4;
  `}
`;

const Button = styled(Nav)`
  ${({ theme }) => css`
    border: 2px solid ${theme.primaryColor};
    width: 100%;
    padding: 12px;
    margin: 0 auto;
    color: ${theme.primaryColor};
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    margin-top: auto;
  `}
`;

const SelectWrapper = styled.div`
  width: 100%;
  margin-bottom: 5px;
`;

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 20px 0;
  z-index: 1;
`;

const Item = styled.li`
  width: 33.333%;
  flex: 0 1 33.333%;
  justify-content: center;
  align-items: center;
  display: flex;

  a {
    width: 80%;
    padding: 15px 0;
  }
`;
